import React from "react";
import { useDispatch, useSelector } from "src/store";
import { HoverRow } from "src/ui/shared/table/HoverRow";
import { MinimalTableCell } from "src/ui/shared/table/MinimalTableComponents";

import { selectClientDetails, showDetails } from "@dashboard/devices/store";
import { flexRender, Row } from "@tanstack/react-table";

import { ResellerClient } from "../../types";

interface TableItemProps {
    row: Row<ResellerClient>;
    index: number;
}

const TableItem = ({ row }: TableItemProps) => {
    const dispatch = useDispatch();
    const details = useSelector(selectClientDetails);

    const handleRowClick = () => {
        if (!row.original.id) {
            return;
        }
        dispatch(
            showDetails({
                type: "client",
                selectedId: row.original.id,
            }),
        );
    };

    return (
        <HoverRow {...row} selected={details?.selectedId === row.original.id}>
            {row.getVisibleCells().map((cell) => (
                <MinimalTableCell
                    key={cell.id}
                    onClick={handleRowClick}
                    fluid={cell.column.columnDef.meta?.fluid}
                    fluidMinWidth={cell.column.columnDef.meta?.fluidMinWidth}
                >
                    {flexRender(cell.column.columnDef.cell, { ...cell.getContext() })}
                </MinimalTableCell>
            ))}
        </HoverRow>
    );
};

export default TableItem;
